import { Widget, WidgetHeader, WidgetBody, WidgetFooter } from "../ui/Widget"
import InfoItem from "../common/InfoItem"
import StartDealerAuditButton from "./StartDealerAuditButton"

export default function DealerInformationWidget({ dealer, isFetching }) {
  if (!dealer && !isFetching) { return null }

  return (
    <Widget>
      <WidgetHeader title="Dealer Information" showSpinner={isFetching} />
      {dealer && (
        <>
          <WidgetBody>
            <div className="w-full text-left">
              <InfoItem title="Dealer Name" data={dealer.name} />
              {dealer.is_suspended && (
                <InfoItem title="Status">
                  <p className="text-md text-yellow">Suspended</p>
                </InfoItem>
              )}
            </div>
          </WidgetBody>
          <WidgetFooter>
            <StartDealerAuditButton dealer={dealer} />
          </WidgetFooter>
        </>
      )}
    </Widget>
  )
}
